import { render } from "./SizesByPallet.vue?vue&type=template&id=8702b70a"
import script from "./SizesByPallet.vue?vue&type=script&lang=js"
export * from "./SizesByPallet.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/components/views/packing_house/production/uniq_final_packing_list/show_container/tabs/sizes_by_pallet.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fpacking_house%2Fproduction%2Funiq_final_packing_list%2Fshow_container%2Ftabs%2FSizesByPallet.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__